import { AsyncPipe, DatePipe } from '@angular/common';
import { AfterViewInit, Component, inject, input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbar } from '@angular/material/toolbar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { Subscription } from 'rxjs';
import { Audit } from 'src/app/models/audit/audit';
import { Auditor } from 'src/app/models/auditor';
import { RecommendationShort } from 'src/app/models/recommendation/recommendation';
import { AzureIdStatusPipe } from 'src/app/pipes/azure-id-status.pipe';
import { AccessService } from 'src/app/services/access.service';
import { RecommendationService } from 'src/app/services/recommendation.service';
import { UserNamePipe } from '../../../pipes/user-name.pipe';

@Component({
  selector: 'app-audit-recommendations',
  templateUrl: './audit-recommendations.component.html',
  styleUrls: ['./audit-recommendations.component.scss'],
  imports: [
    MatToolbar,
    MatButton,
    RouterLink,
    MatPaginator,
    DatePipe,
    AzureIdStatusPipe,
    AsyncPipe,
    MatSortModule,
    MatTableModule,
    UserNamePipe
  ]
})
export class AuditRecommendationsComponent implements OnInit, AfterViewInit, OnDestroy {
  private recommendationService = inject(RecommendationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private accessService = inject(AccessService);

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('recPaginator') paginator!: MatPaginator;

  readonly form = input.required<UntypedFormGroup>();
  readonly audit = input.required<Audit>();
  subs: Subscription[] = [];
  recTable = {
    ready: false,
    data: new MatTableDataSource<RecommendationShort>(),
    col: [
      { title: 'Title', field: 'title' },
      {
        title: 'Deadline',
        field: 'currentDeadlineDate',
        custom: 'currentDeadlineDate'
      },
      { title: 'Status', field: 'status' },
      {
        title: 'Auditee',
        field: 'assessmentCoordinator',
        custom: 'name'
      },
      {
        title: 'Created on',
        field: 'createdOn',
        custom: 'createdOn'
      }
    ]
  };

  ngOnInit() {
    this.fillTable();
    this.accessService.initRoles();
  }

  navCreateRecommendation() {
    const routerLink = '/audit_detail/' + this.form().get('id')?.value + '/recommendation_new/1';
    this.router.navigate([routerLink], {
      state: { audit: this.audit() },
      relativeTo: this.route
    });
  }

  fillTable() {
    if (this.audit().id) {
      this.recommendationService.getByAudit(this.audit().id).subscribe({
        next: (recommendations) => {
          this.recTable.data.data = recommendations;
          this.recTable.ready = true;
        }
      });
    }
  }

  ngAfterViewInit() {
    this.recTable.data.sort = this.sort;
    this.recTable.data.paginator = this.paginator;
  }

  ngOnDestroy() {
    this.subs.forEach((v) => v.unsubscribe());
  }

  colFields(col: { field: string }[]) {
    return col.map((v) => v.field);
  }

  canCreate() {
    switch (this.audit()?.auditor) {
      case Auditor.GPRM:
        return this.accessService.isGprmAuditor();
      case Auditor.GPIA:
        return this.accessService.isGpiaAuditor();
    }
    return false;
  }
}
